import { render, staticRenderFns } from "./PremiumMemberBadge.vue?vue&type=template&id=5f3f0344&scoped=true"
import script from "./PremiumMemberBadge.vue?vue&type=script&lang=ts"
export * from "./PremiumMemberBadge.vue?vue&type=script&lang=ts"
import style0 from "./PremiumMemberBadge.vue?vue&type=style&index=0&id=5f3f0344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f0344",
  null
  
)

export default component.exports